import { CustomWaterLoading } from 'src/components';
import { HeaderOnlyLayout } from 'src/layouts';

export const LoadingElement = () => (
  <HeaderOnlyLayout>
    <CustomWaterLoading />
  </HeaderOnlyLayout>
);
